import React from 'react'

import { LayoutEditorAttributeProps } from 'v2/blocks/types'

export const DataListBlockContext =
    React.createContext<LayoutEditorAttributeProps<DataListBlock> | null>(null)
